export function formatDurationShort(seconds?: number | null): string {
  if (seconds == null || Number.isNaN(seconds)) {
    return "—";
  }

  const totalSeconds = Math.round(seconds);
  const minutes = Math.floor(totalSeconds / 60);
  const remainingSeconds = totalSeconds % 60;

  if (minutes === 0) {
    return `${remainingSeconds}s`;
  }

  return `${minutes}m ${remainingSeconds}s`;
}

export function formatPercent(numerator: number, denominator: number): string {
  if (!denominator) {
    return "—";
  }

  return `${Math.round((numerator / denominator) * 100)}%`;
}

export function getLastSevenDaysRange(): { start: Date; end: Date } {
  const end = new Date();
  const start = new Date(end);
  start.setDate(start.getDate() - 7);

  return { end, start };
}

// Matches the "%Y-%m-%d" (UTC) grouping the analytics API's dailyTrend aggregation uses.
export function getLastSevenDayKeys(): string[] {
  const now = new Date();

  return Array.from({ length: 7 }, (_, index) => {
    const date = new Date(now);
    date.setUTCDate(date.getUTCDate() - (6 - index));
    return date.toISOString().slice(0, 10);
  });
}

export function fillDailyTrend(
  dailyTrend: { date: string; count: number }[],
  days: string[],
): { date: string; count: number }[] {
  const countsByDate = new Map(
    dailyTrend.map((bucket) => [bucket.date, bucket.count]),
  );

  return days.map((date) => ({ date, count: countsByDate.get(date) ?? 0 }));
}

// Rounds a raw max value up to a "nice" chart-axis ceiling (1/2/5/10 × a power of ten).
export function getNiceAxisMax(rawMax: number): number {
  if (rawMax <= 0) {
    return 5;
  }

  const magnitude = Math.pow(10, Math.floor(Math.log10(rawMax)));
  const normalized = rawMax / magnitude;

  const niceNormalized =
    normalized <= 1 ? 1 : normalized <= 2 ? 2 : normalized <= 5 ? 5 : 10;

  return niceNormalized * magnitude;
}
